import { observable, action } from 'mobx';
import { State } from "./state";
import { Request } from "@/network/request"
import Vue from 'vue';
import router from '@/router'
import {i18n} from '@/i18n'

export default class authStore {
    @observable token = null
    @observable user = null
    
    loginState = new State();

    @action login(payload) {
        let request = new Request('post', '/auth/login', payload)
        this.loginState.trigger(async () => {
            return await (await request.send());
        },
            {
                onSuccess: (value) => {
                    if (value.status == 'success') {
                        if (value.data.verified) {
                            this.user = value.data
                            localStorage.setItem('dmtoken', value.data.token)
                            localStorage.setItem('dmuser', JSON.stringify( value.data.user ))

                            Vue.$toast.open({
                                message: i18n.t("toastAlert.loggedIn"),
                                type: 'success',
                            });
                            
                            router.push('/')
                        } 
                    }
                }, onError: (error) => {
                    Vue.$toast.open({
                        message: error,
                        type: 'error',
                    });
                }

            });
    }
    @action logout() {
        localStorage.removeItem('dmtoken')
        localStorage.removeItem('dmuser')
        router.push('/login')

        Vue.$toast.open({
            message: i18n.t("toastAlert.loggedOut"),
            type: 'success',
        });
    }
    @action getUser() {
        this.user = JSON.parse(localStorage.getItem('dmuser'))
    }

}
export const Store = new authStore();